import { UnitTransferUnitsLocationEnumType } from '__generated__/graphql';

export default function unitTransferUnitsLocationToReadable(
  location: UnitTransferUnitsLocationEnumType
): string {
  switch (location) {
    case UnitTransferUnitsLocationEnumType.AlTrustEscrow:
      return 'AL Trust Escrow';
    case UnitTransferUnitsLocationEnumType.OwnDemat:
      return 'Own Demat';
    default:
      return location;
  }
}
